<aux-input
  [type]="type"
  [placeholder]="formControlConstants.PLACEHOLDER.DATE"
  [formControl]="fc"
  [autofocus]="true"
  [min]="min"
  [max]="max"
  class="aux-ag-date-picker"
></aux-input>
